import { motion } from "framer-motion";
import { fadeUp, useCounter } from "@/lib/anim";

export function AnimatedCounter({ value, prefix = "", suffix = "", decimals, className = "" }) {
  const auto = value % 1 !== 0 ? 1 : 0;
  const { ref, display } = useCounter(value, decimals ?? auto);
  return (
    <span ref={ref} className={className}>
      {prefix}
      {display}
      {suffix}
    </span>
  );
}

export function Reveal({ children, i = 0, className = "", as: Tag = "div" }) {
  const MotionTag = motion[Tag] || motion.div;
  return (
    <MotionTag
      className={className}
      variants={fadeUp}
      custom={i}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-80px" }}
    >
      {children}
    </MotionTag>
  );
}

export function SectionHeader({ chapter, kicker, title, subtitle, center = false }) {
  return (
    <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""} mb-16 md:mb-24`}>
      {chapter && (
        <Reveal className="mb-4">
          <span className="font-display italic text-auvra-blue text-2xl md:text-3xl">{chapter}</span>
        </Reveal>
      )}
      {kicker && (
        <Reveal i={1} className="kicker mb-6 block">{kicker}</Reveal>
      )}
      <Reveal i={2}>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05]">
          {title}
        </h2>
      </Reveal>
      {subtitle && (
        <Reveal i={3}>
          <p className="text-base md:text-lg text-secondary-auvra leading-relaxed mt-6">{subtitle}</p>
        </Reveal>
      )}
    </div>
  );
}
